import React, { useRef, useState, useMemo } from 'react';
import { NewModal as Modal, CompositeTable as Table, Button, Heading, Row, Col, themes } from '@digitools/honest-react';
import SubsLocsColumns from '../../../Constants/SubsLocsColumns';
import { useFormApi } from 'informed';
import { getSelectedClaimProductsFromFormApi } from '../FilterMyReportValidation';
import { useDisclosure } from '@mantine/hooks';
const ButtonLabelText = {
    SelectAll: 'Select all subsidiaries/locations',
    DeselectAll: 'Deselect all subsidiaries/locations',
};
const SubLocModal = ({ getSelected, data, selectedSubLocs, reportFilterCategory }) => {
    const tableApi = useRef({ setSelectedData: () => { } });
    const getSelectedRef = useRef([]);
    const formApi = useFormApi();
    const [buttonLabels, setDoSelectAll] = useState();
    const [selectedLocationCount, setSelectedLocationCount] = useState(0);
    const getSelectAllButtonLabel = (selectedArrayLength) => {
        setSelectedLocationCount(selectedArrayLength);
        setDoSelectAll(selectedArrayLength === data.length ? ButtonLabelText.DeselectAll : ButtonLabelText.SelectAll);
    };
    const setTableApi = (api) => {
        tableApi.current = api;
    };
    const isOpenButtonDisabled = reportFilterCategory === '' ||
        (reportFilterCategory === 'Claim' && ((typeof formApi.getValue === 'function' && getSelectedClaimProductsFromFormApi(formApi)) || []).length === 0);
    const FooterPrimaryRenderButton = () => {
        getSelected(getSelectedRef);
    };
    const selectDeSelectSubsLoc = () => buttonLabels === ButtonLabelText.SelectAll
        ? tableApi.current.setSelectedData(data)
        : tableApi.current.setSelectedData([]);
    const table = useMemo(() => (<Table title={'subsidiary and location table'} data={data} theme={themes.rebrand} defaultPageSize={10} columns={SubsLocsColumns} paginated={true} filterable={true} isSelectable={true} selectedRef={getSelectedRef} rowIdentifier={'locationId'} data-testid={'subLocTable'} tableApi={setTableApi} onSelectedChange={(selected) => getSelectAllButtonLabel(selected.length)}/>), [data, SubsLocsColumns, tableApi]);
    const [isOpen, { open, close }] = useDisclosure(false);
    return (<>
      <Modal title={'Modify subsidiaries/locations'} centered={true} opened={isOpen} onClose={() => {
            tableApi.current.setSelectedData(selectedSubLocs);
            close();
        }} cancelButtonText={'Cancel'} submitButtonText={'Save Changes'} onSubmit={() => {
            FooterPrimaryRenderButton();
            close();
        }} cancelButtonProps={{
            'data-testid': 'cancelSubLocs',
            buttonType: 'text',
            'aria-label': 'cancel subsidiaries/locations modal'
        }} submitButtonProps={{
            'data-testid': 'saveSubLocs',
            buttonType: 'primary',
            'aria-label': 'save subsidiaries/locations modal'
        }} theme={themes.rebrand} closeOnClickOutside={true} size={'1100px'}>

        <Row style={{ alignItems: 'center' }}>
          <Col>
            <Heading style={{ marginBottom: '10px' }} data-testid={'selectedSubLocHeader'} elemType={'h6'}>
              {selectedLocationCount} of {data.length} subsidiaries/locations selected
            </Heading>
          </Col>
          <Col>
            <Button style={{ marginBottom: '15px', float: 'right', textAlign: 'right', paddingRight: '0rem' }} theme={themes.rebrand} data-testid={'selectSubs'} type={'button'} onClick={selectDeSelectSubsLoc}>
              {buttonLabels}
            </Button>
          </Col>
        </Row>
        {table}
      </Modal>
      <Button buttonType={'text'} data-testid={'openModal'} type={'button'} onClick={open} disabled={isOpenButtonDisabled}>
        Modify subsidiaries/locations
      </Button>
    </>);
};
export default SubLocModal;
